

export let colValuePatient =    {
                                    colId: 'valuePatient',
                                    headerName: 'Value - Patient',
                                    field: 'valuePatient',
                                    width: 50,
                                    type: 'number',
                                    cellRenderer: currencyFormatter,
                                    sortable: true
                                };

export let colValueHour =   {
                                colId: 'valueHour',
                                headerName: 'Value - Hour',
                                field: 'valueHour',
                                width: 50,
                                type: 'number',
                                cellRenderer: currencyFormatter,
                                sortable: true
                            };

export let colValueDay =    {
                                colId: 'valueDay',
                                headerName: 'Value - Day',
                                field: 'valueDay',
                                width: 50,
                                type: 'number',
                                cellRenderer: currencyFormatter,
                                sortable: true
                            };

export let colValueMonth =  {
                                colId: 'valueMonth',
                                headerName: 'Value - Month',
                                field: 'valueMonth',
                                width: 50,
                                type: 'number',
                                cellRenderer: currencyFormatter,
                                sortable: true
                            };

export let colValueResidentPerYear =    {
                                            colId: 'valueResidentPerYear',
                                            headerName: 'Value - Resident Per Year',
                                            field: 'valueResidentPerYear',
                                            width: 50,
                                            type: 'number',
                                            cellRenderer: currencyFormatter,
                                            sortable: true
                                        };

export let colValuePerDiem =    {
                                    colId: 'valuePerDiem',
                                    headerName: 'Value - Per Diem',
                                    field: 'valuePerDiem',
                                    width: 50,
                                    type: 'number',
                                    cellRenderer: currencyFormatter,
                                    sortable: true
                                };

export let colValueEncounter =  {
                                    colId: 'valueEncounter',
                                    headerName: 'Value - Encounter',
                                    field: 'valueEncounter',
                                    width: 50,
                                    type: 'number',
                                    cellRenderer: currencyFormatter,
                                    sortable: true
                                };

export let colValueDelivery =   {
                                    colId: 'valueDelivery',
                                    headerName: 'Value - Delivery',
                                    field: 'valueDelivery',
                                    width: 50,
                                    type: 'number',
                                    cellRenderer: currencyFormatter,
                                    sortable: true
                                };

export let colValueWorkshop =   {
                                    colId: 'valueWorkshop',
                                    headerName: 'Value - Workshop',
                                    field: 'valueWorkshop',
                                    width: 50,
                                    type: 'number',
                                    cellRenderer: currencyFormatter,
                                    sortable: true
                                };
                                
export let colValueClinic =     {
                                    colId: 'valueClinic',
                                    headerName: 'Value - Clinic',
                                    field: 'valueClinic',
                                    width: 50,
                                    type: 'number',
                                    cellRenderer: currencyFormatter,
                                    sortable: true
                                };

export let colValueClass =  {
                                colId: 'valueClass',
                                headerName: 'Value - Class',
                                field: 'valueClass',
                                width: 50,
                                cellRenderer: currencyFormatter,
                                sortable: true
                            };

export let colValueEvent =  {
                                colId: 'valueEvent',
                                headerName: 'Value - Event',
                                field: 'valueEvent',
                                width: 50,
                                type: 'number',
                                cellRenderer: currencyFormatter,
                                sortable: true
                            };

export let colValueProgram =    {
                                    colId: 'valueProgram',
                                    headerName: 'Value - Program',
                                    field: 'valueProgram',
                                    width: 50,
                                    cellRenderer: currencyFormatter,
                                    sortable: true
                                };

export let colValueStudentPerWeek =     {
                                            colId: 'valueStudentPerWeek',
                                            headerName: 'Value - Student Per Week',
                                            field: 'valueStudentPerWeek',
                                            width: 50,
                                            type: 'number',
                                            cellRenderer: currencyFormatter,
                                            sortable: true
                                        };

export let colValueStudentPerMonth =    {
                                            colId: 'valueStudentPerMonth',
                                            headerName: 'Value - Student Per Month',
                                            field: 'valueStudentPerMonth',
                                            width: 50,
                                            type: 'number',
                                            cellRenderer: currencyFormatter,
                                            sortable: true
                                        };



export let allColumns = [
    colValuePatient,
    colValueHour,
    colValueDay,
    colValueMonth,
    colValueResidentPerYear,
    colValuePerDiem,
    colValueEncounter,
    colValueDelivery,
    colValueWorkshop,
    colValueClinic,
    colValueClass,
    colValueEvent,
    colValueProgram,
    colValueStudentPerWeek,
    colValueStudentPerMonth
];


export let columnSelectList = [
    {
        value: colValuePatient,
        viewValue: colValuePatient.headerName
    },
    {
        value: colValueHour,
        viewValue: colValueHour.headerName
    },
    {
        value: colValueDay,
        viewValue: colValueDay.headerName
    },
    {
        value: colValueMonth,
        viewValue: colValueMonth.headerName
    },
    {
        value: colValueResidentPerYear,
        viewValue: colValueResidentPerYear.headerName
    },
    {
        value: colValuePerDiem,
        viewValue: colValuePerDiem.headerName
    },
    {
        value: colValueEncounter,
        viewValue: colValueEncounter.headerName
    },
    {
        value: colValueDelivery,
        viewValue: colValueDelivery.headerName
    },
    {
        value: colValueWorkshop,
        viewValue: colValueWorkshop.headerName
    },
    {
        value: colValueClinic,
        viewValue: colValueClinic.headerName
    },
    {
        value: colValueEvent,
        viewValue: colValueEvent.headerName
    },
    {
        value: colValueProgram,
        viewValue: colValueProgram.headerName
    },
    {
        value: colValueStudentPerWeek,
        viewValue: colValueStudentPerWeek.headerName
    },
    {
        value: colValueStudentPerMonth,
        viewValue: colValueStudentPerMonth.headerName
    }
];


function currencyFormatter(params) {

    let usdFormate = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0
    });

    if (usdFormate.format(params.value) == '$0' ||
        (usdFormate.format(params.value) == '$NaN')) {
      return '$0.00';
    } else {
      return usdFormate.format(params.value);
    }

  }

